var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{staticClass:"c-loading"},[_c('b-progress',{staticClass:"c-loading__progress-bar",attrs:{"value":_vm.percent,"variant":"danger","striped":"","animated":""}}),_c('div',{staticClass:"c-loading--fade"})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }